module.exports = __webpack_public_path__ + "img/reservations-followed-add.3f823d81.svg";